import { ArrowRightIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { AuthEmailButton } from '~/modules/auth/auth-email-button';
import { useAuthStore } from '~/modules/auth/auth-store';
import { LegalNotice } from '~/modules/auth/legal-notice';
import { WaitlistForm } from '~/modules/requests/waitlist-form';

export function WaitlistStep() {
  const { t } = useTranslation();

  const email = useAuthStore((state) => state.email);
  const resetSteps = useAuthStore((state) => state.resetSteps);

  return (
    <>
      <div className="text-center text-2xl">
        <h1>{t('c:request_access')}</h1>
        {email.length > 0 && <AuthEmailButton email={email} onClick={resetSteps} className="mt-2" />}
      </div>
      <LegalNotice email={email} mode="waitlist" />
      {/* Stacked like the email step; the form's own row layout serves the pricing dialog */}
      <WaitlistForm
        email={email}
        className="flex-col items-stretch"
        inputClassName="h-12"
        buttonContent={
          <>
            {t('c:request_access')}
            <ArrowRightIcon />
          </>
        }
      />
    </>
  );
}
